import * as React from 'react'
import { useCallback } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'

import {
  useSchedulingWizard,
  closeActionCreator as close,
} from './wizardContext'
import { modeToDrawerTitle } from '../utils'
import { SchedulingWizard } from './SchedulingWizard'

export function SchedulingDrawer() {
  const [{ mode }, dispatch] = useSchedulingWizard()

  const open = !!mode

  const title = modeToDrawerTitle(mode)

  const onClose = useCallback(() => dispatch(close()), [dispatch])

  return (
    <Dialog
      scroll="paper"
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          height: 'calc(100vh - 64px)',
          maxHeight: '706px',
          overflowX: 'hidden',
          width: {
            xs: '95vw',
            sm: '602px',
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 0,
          height: '72px',
          pl: '24px',
          pr: '15px',
        }}
      >
        <Typography
          variant={'h6'}
          sx={{
            color: (theme) => theme.palette.text.primary,
          }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <SchedulingWizard />
    </Dialog>
  )
}
